import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose Us for Mobile App Development in Dubai?</h2>
            <p>
              For a number of strong reasons, choosing TekRevol as a{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development-company-dubai">
                mobile app development company in Dubai
              </Link>{" "}
              is a prudent move. First and foremost, our team possesses a wealth
              of knowledge, with professional Android app developers in Dubai
              that have created mobile apps targeted to the numerous businesses
              prominent in Dubai. We are devoted to staying ahead of
              Dubai-specific technology developments, guaranteeing that your app
              benefits from cutting-edge solutions. What distinguishes our
              commitment to providing unique Android app development in Dubai is
              our awareness that each organization in Dubai has distinct
              requirements, and we customize our solutions to meet those needs.
              Furthermore, our focus on pricing ensures that you receive
              high-quality apps designed specifically for Dubai without breaking
              the bank. Your satisfaction is our main priority, and we value
              your feedback and concerns so that we can design an app that is
              completely aligned with your Dubai company goals.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <StaticImage
              src="../../images/location_new/fold7/and_dubai.webp"
              alt="Android-app-developers-uk"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={525}
              height={804}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
